import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {FormsModule} from '@angular/forms';
import {RouterModule} from '@angular/router';

import {CustomTableComponent} from './custom-table.component';
import {CustomTableFilteringDirective} from './custom-table-filtering.directive';
import {CustomTableSortingDirective} from './custom-table-sorting.directive';

// flexbox
import {FlexLayoutModule} from '@angular/flex-layout';

@NgModule({
  imports: [CommonModule, FlexLayoutModule, NgbModule, FormsModule, RouterModule],
  declarations: [CustomTableComponent, CustomTableFilteringDirective, CustomTableSortingDirective],
  exports: [CustomTableComponent, CustomTableFilteringDirective, CustomTableSortingDirective]
})
export class CustomTableModule {
}
